import { makeEndpointFns } from '../fns';
import { UserAccountNameModel, UserApiResponse } from '@/user/user';

const { GET, POST, DELETE } = makeEndpointFns('storeManager');

export const accounts = {
    getAccountName: GET('api/v1/accountManager/{accountGuid}/name', UserAccountNameModel),
    /** Returns the updated account */
    setOrganization: POST('api/v1/accountManager/updateOrganization/{accountGuid}/{organizationId}', UserApiResponse),
    /** Returns the updated account */
    removeOrganization: DELETE('api/v1/accountManager/organization/{accountGuid}', UserApiResponse),
};
